import dynamic from 'next/dynamic';

const DealExpressBuyButtonDynamic = dynamic(() =>
  import('./DealExpressBuyButton'),
);

export default DealExpressBuyButtonDynamic;
